import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { FortuneProvider } from './contexts/FortuneContext';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import CategoryPage from './pages/CategoryPage';
import ProductDetailPage from './pages/ProductDetailPage';
import BirthInputPage from './pages/BirthInputPage';
import PaymentPage from './pages/PaymentPage';
import ResultPage from './pages/ResultPage';
import LoginPage from './pages/LoginPage';
import MyPage from './pages/MyPage';
import HistoryPage from './pages/HistoryPage';
import './i18n/i18n';
import './styles/index.css';

// Auth guard for protected routes
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('user') !== null;
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function App() {
  // Initialize images folder
  useEffect(() => {
    // This would normally be handled by your build process
    // For this demo, we're just creating a placeholder
    console.log('App initialized');
  }, []);

  return (
    <Router>
      <AuthProvider>
        <FortuneProvider>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<HomePage />} />
              <Route path="categories/:categoryId" element={<CategoryPage />} />
              <Route path="product/:productId" element={<ProductDetailPage />} />
              <Route path="birth-input" element={<BirthInputPage />} />
              <Route path="payment" element={<PaymentPage />} />
              <Route path="result" element={<ResultPage />} />
              <Route path="login" element={<LoginPage />} />
              <Route 
                path="mypage" 
                element={
                  <ProtectedRoute>
                    <MyPage />
                  </ProtectedRoute>
                } 
              />
              <Route path="history" element={<HistoryPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </FortuneProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
